<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>

<div class="contenedor columns " style="height:100%; ">
  <div class="column is-2 is-hidden-mobile menu-izquierda">

    <!-- Menu izquierda del modulo enviroment" -->
    <app-sistema-menu-aside></app-sistema-menu-aside>
  </div>
  <div class="column" style="padding:0px;">
    <div style="background: #FFF; border-radius: 1em; ">
      <app-filtros-reportes #ctrl [datos]="datos" [cargando]="cargando" ruta="resumen/venta"></app-filtros-reportes>

      <div style="overflow:auto; height: 77.5vh;">
        <div id="imprimir">
          <!--Tabla -->
          <table class="table is-striped  is-fullwidth" *ngIf="!cargando " id="tabla">
            <thead>
              <tr>
                <th>Nivel</th>
                <th>Folio</th>
                <th>Código</th>
                <th>Cliente</th>
                <th>Subtotal</th>
                <th>Descuento</th>
                <th>Total</th>
                <th>Pago</th>
                <th>Facturado</th>
                <th>Pagado el</th>

                <th>Cajero</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of ctrl.datos; let i=index">
                <th>{{ item.nivel_educativo }}</th>
                <th>{{ item.folio }}</th>
                <td>
                  <strong>{{item.codigo}} </strong>
                </td>
                <td>{{ item.cliente?.nombre }}</td>
                <td>{{ item.subtotal | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}</td>
                <td>{{ item.descuento | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}} </td>
                <td>{{ item.total | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}</td>
                <th>
                  <span class="tag" *ngFor="let p of item.pagos; ">{{ p.nombre }}</span>
                </th>
                <th>{{ item.facturado > 0 ? 'Si' : 'No'}}</th>
                <td>{{ item.created_at | formatoFecha }} </td>

                <td>{{ item.cajero?.nombre }}</td>
              </tr>
              <tr *ngIf="ctrl.datos.length == 0">
                <td colspan="6" style="vertical-align: middle; color:#888;">Esta lista está vacía.</td>
              </tr>
            </tbody>
          </table>
          <table class="table is-striped  is-fullwidth" *ngIf="!cargando" id="tabla2">
            <thead>
              <tr>
                <th align="right">
                  <div align="right">Subtotal</div>
                </th>
                <th>
                  <div align="left">{{ctrl.subtotal | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}
                  </div>
                </th>


              </tr>

              <!-- <tr>
                <th align="right">
                  <div align="right">Descuento</div>
                </th>
                <th></th>
                <th>
                  <div align="left">{{ctrl.descuento | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}
                  </div>
                </th>
                <th></th>
              </tr>
              <tr>
                <th align="right">
                  <div align="right">Total</div>
                </th>
                <th></th>
                <th></th>
                <th>
                  <div align="left">{{ctrl.gran_total | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}
                  </div>
                </th>
              </tr> -->
            </thead>
           
            <tbody>
              <tr>
                <td align="right">
                  <div align="right">Descuento</div>
                </td>

                <th>
                  <div align="left">{{ctrl.descuento | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}
                  </div>
                </th>
              </tr>

              <tr>
                <th align="right">
                  <div align="right">Total</div>
                </th>

                <th>
                  <div align="left">{{ctrl.gran_total | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}
                  </div>
                </th>
              </tr>
            </tbody>
          </table>
          <table class="table is-striped  is-fullwidth" *ngIf="!cargando" id="tabla3">
            <thead>
              <tr *ngFor="let item of niveles_educativos; let i=index">
                <th style="color: blue">Total {{item.nombre}}</th>
                <th style="color: blue">{{total_niveles_educativos[item.id] |
                  currency:configuracion.sucursal.moneda:'symbol-narrow'}}</th>
              </tr>
            </thead>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>